// extracted by mini-css-extract-plugin
module.exports = {"ContextMenu":"ContextMenu_ContextMenu__1Cjgu","button":"ContextMenu_button__3xNr-","text":"ContextMenu_text__ytjX9","shortcut":"ContextMenu_shortcut__6tTol"};